/* import __COLOCATED_TEMPLATE__ from './button-close-x.hbs'; */
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['dialog__header__close', 'button--tertiary'],
  tagName: 'button',
  // Prevent from submitting forms via default `submit` type
  type: 'button',
  attributeBindings: ['type', 'data-test-dialog-close-icon', 'aria-label'],
  'data-test-dialog-close-icon': true,
  'aria-label': 'Close'
});